<template>
  <div>
    <a-button
      type="primary"
      :disabled="record.invoiceState != 1"
      @click="showModal"
    >
      申请
    </a-button>
    <a-modal v-model="visible" title="交易流水" on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确定
        </a-button>
      </template>
      <a-descriptions title="开票申请">
        <a-descriptions-item label="税号">
          {{ record.broughtAccount }}</a-descriptions-item
        >
        <a-descriptions-item label="企业名称"
          >{{ record.userName }}
        </a-descriptions-item>
        <a-descriptions-item label="交易日期"
          >{{ record.createTime }}
        </a-descriptions-item>
        <a-descriptions-item label="交易类型"
          >{{ record.remark }}
        </a-descriptions-item>

        <a-descriptions-item label="交易金额">
          {{ record.money }}</a-descriptions-item
        >
        <a-descriptions-item label="开户行">
          {{ record.openingBankName }}</a-descriptions-item
        >

        <a-descriptions-item label="开户账户">
          {{ record.companyAccount }}</a-descriptions-item
        >
        <a-descriptions-item label="发票类型">
          <a-select
            label-in-value
            :default-value="{ key: '请选择类型' }"
            style="width: 120px"
            @change="onchange"
          >
            <a-select-option value="1"> 普通发票</a-select-option>
            <a-select-option value="2"> 专用发票</a-select-option>
          </a-select>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>
<script>
import { Requesapply, getTransactions } from "@/api/balance";
export default {
  props: {
    record: {
      type: Object,
    },
    searchForm: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      visible: false,
      records: {},
    };
  },
  methods: {
    showModal() {
      this.visible = true;
      console.log(this.record.id);
    },
    handleOk(e) {
      this.visible = false;
      this.$emit('getList')
    },
    handleCancel(e) {
      this.visible = false;
    },
    onchange(e) {
      console.log(e, this.record.id);
      let params = {
        id: this.record.id,
        invoiceType: e.key,
      };
      Requesapply(params).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
